'use client';
import { useRouter } from 'next/navigation';
import { TbChevronRight } from 'react-icons/tb';
import Styles from './mobileHeader.module.scss';
import { useInRouterContext, Link } from 'react-router-dom';
import { PATH } from 'data';
import { __MobileHeaderPropsType } from './mobileHeader.type';

const MobileHeaderComp = ({ title, onIconClick, help, backPath }: __MobileHeaderPropsType) => {
    const nextRouter = useRouter();
    const routerDomContext = useInRouterContext();
    const arrow = (onClick?: () => void) => (
        <TbChevronRight
            className="pointer t-white t-d-gray3"
            size={18}
            onClick={() => {
                if (onClick) onClick();
            }}
        />
    );
    const onBack = () => {
        if (onIconClick) onIconClick();
        else if (!routerDomContext) nextRouter.back();
    };
    const link =
        routerDomContext && !onIconClick ? (
            <Link className="center-content" to={backPath ?? PATH.panel.mobileMenu()}>
                {arrow()}
            </Link>
        ) : (
            arrow(onBack)
        );

    return (
        <div
            className={`${Styles['container']} d-md-none align-items-center justify-content-between ph-3 bg-black1 bg-d-black2`}
        >
            <div className="align-items-center g-1">
                {link}
                <p className="t-p1 t-white-i t-d-gray3-i">{title}</p>
            </div>
            {help}
        </div>
    );
};
export default MobileHeaderComp;
